export default "__VITE_ASSET__B26AJEiM__"